import * as React from 'react';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './style.css';

interface IFloorPlanHeaderProps {
  onClose(): void;
}

export const FloorPlanHeader = ({ onClose }: IFloorPlanHeaderProps): React.JSX.Element => {
  return (
    <div className={styles['close']}>
      <button type="button" onClick={onClose} className={styles['close_button']} aria-label="Закрыть">
        <IconActionClose16 />
      </button>
    </div>
  );
};
